import React from 'react';
import ReactDOM from 'react-dom';
import { useTranslation } from 'react-i18next';
import './CustomModal.css';

const CustomModal = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  width = 500,
  showCancel = true,
  showConfirm = true,
  cancelText,
  confirmText,
  onConfirm,
  onCancel,
  type = 'info' // 'info', 'confirm', 'warning'
}) => {
  const { t } = useTranslation(['common']);
  
  // 设置默认值
  const defaultCancelText = cancelText || t('common:actions.cancel', { defaultValue: 'Cancel' });
  const defaultConfirmText = confirmText || t('common:actions.confirm', { defaultValue: 'Confirm' });
  if (!isOpen) return null;

  const handleConfirm = () => {
    if (onConfirm) {
      onConfirm();
    }
    onClose();
  };

  const handleCancel = () => {
    if (onCancel) {
      onCancel();
    }
    onClose();
  };

  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  const modalContent = (
    <div className="custom-modal-overlay" onClick={handleBackdropClick}>
      <div 
        className={`custom-modal ${type}`} 
        style={{ width: width }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="custom-modal-header">
          <h3 className="custom-modal-title">{title}</h3>
          <button 
            className="custom-modal-close" 
            onClick={onClose}
            aria-label={t('common:actions.close', { defaultValue: 'Close' })}
          >
            ×
          </button>
        </div>
        
        <div className="custom-modal-body">
          {children}
        </div>
        
        {(showCancel || showConfirm) && (
          <div className="custom-modal-footer">
            {showCancel && (
              <button 
                className="custom-modal-btn custom-modal-btn-cancel" 
                onClick={handleCancel}
              >
                {defaultCancelText}
              </button>
            )}
            {showConfirm && (
              <button 
                className={`custom-modal-btn custom-modal-btn-confirm ${type === 'danger' ? 'danger' : ''}`}
                onClick={handleConfirm}
              >
                {defaultConfirmText}
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );

  return ReactDOM.createPortal(modalContent, document.body);
};

export default CustomModal; 